import { Platform, StyleProp, StyleSheet, ViewStyle, View } from 'react-native';

import Colors from '../../constants/Colors';
import Layout from '../../constants/Layout';
import useColorScheme from '../../hooks/useColorScheme';
import { TextH3 } from '../StyledText';

export function ProfileAvatar({
  letter,
  style,
  textComponent: TextComponent = TextH3,
}: {
  letter: string;
  style?: StyleProp<ViewStyle>;
  textComponent?: React.ElementType;
}) {
  const theme = useColorScheme();

  return (
    <View
      style={[styles.dot, { backgroundColor: Colors[theme].accent }, style]}
    >
      <TextComponent>{letter}</TextComponent>
    </View>
  );
}

const styles = StyleSheet.create({
  dot: {
    alignItems: 'center',
    justifyContent: 'center',
    ...Platform.select({
      web: {
        ...(Layout.isLargeDevice && {
          alignSelf: 'center',
          width: 70,
          height: 70,
          borderRadius: 35,
        }),
        ...(Layout.isMobileDevice && {
          width: 50,
          height: 50,
          borderRadius: 25,
        }),
      },
    }),
    marginBottom: 20,
  },
});
